import { useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import { convertUserLoginToSharepointUser } from "../../../../services/util";
const ContentComment = (props: any) => {
  const { onCloseContentComment, isOpenContentComment, onValueComment, user, onClose } = props;
  const [comment, setComment] = useState(null as any);

  const handleOnSubmit = async (event: any) => {
    event.stopPropagation();
    if (onCloseContentComment) {
      onCloseContentComment(comment);
    }
    onClose();
    setComment("");
  };

  const changeComment = (e: any) => {
    setComment(e.target.value);
  };

  const getComment = () => {
    if (onValueComment) {
      let arrComments: any = JSON.parse(onValueComment);
      let indexCommnetUser: any = arrComments.findIndex(
        (c: any) => c.User.id === convertUserLoginToSharepointUser(user).id
      );
      return indexCommnetUser !== -1 ? arrComments[indexCommnetUser].Comment : null;
    }
  };

  return (
    <Modal show={isOpenContentComment} onHide={onClose} centered size={"lg"} className="add-folder-modal">
      <Modal.Header closeButton>
        <Modal.Title>Ý kiến</Modal.Title>
      </Modal.Header>
      <Form noValidate onSubmit={handleOnSubmit}>
        <Modal.Body className="py-3 px-5">
          <div>
            <textarea
              autoFocus={true}
              rows={5}
              onChange={changeComment}
              defaultValue={comment ? comment : getComment()}
              className="py-2 w-100 md-4"
              style={{ paddingInline: "10px" }}
            />
            <br />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="info" onClick={handleOnSubmit}>
            Đóng góp ý kiến
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};
export default ContentComment;
